import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white px-6 py-20 sm:py-24" aria-labelledby="garantia-titulo" data-id="element-58" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex max-w-4xl flex-col items-start gap-8 rounded-3xl border border-forest-100 bg-forest-50 p-8 sm:flex-row sm:p-12" data-id="element-59" data-mp="9tthweepe508">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-forest-600" data-id="element-60" data-mp="eur1mvfd373u">
          <ShieldCheckIcon className="h-8 w-8 text-cream-50" aria-hidden="true" data-id="element-61" data-mp="jqg3j5eut03b" />
        </span>
        <div data-id="element-62" data-mp="nsazrvhxgna8">
          <p className="text-sm font-semibold text-forest-600" data-id="element-63" data-mp="nrrlcorhkh0y">Tu inversión está 100% protegida</p>
          <h2 id="garantia-titulo" className="mt-2 font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl" data-id="element-64" data-mp="sn6wva20u0u7">
            Garantía de 7 días, sin preguntas
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-forest-700/75" data-id="element-65" data-mp="17hv6n0egflfm">
            Abrís los volúmenes. Los usás en clase. Si en 7 días no es lo que esperabas, solicitás tu
            devolución completa. Devolución del 100% sin formularios, sin condiciones.
          </p>
          <p className="mt-6 inline-block rounded-full bg-white px-4 py-2 text-sm font-semibold text-forest-700" data-id="element-66" data-mp="20v6u639nk4f5">
            Tasa de devoluciones: menor al 1%
          </p>
        </div>
      </div>
    </section>;
}